import { isEmpty } from 'lodash';

const getCurrentCustomerId = () => {
    const storage = window.localStorage;
    const userId = storage.getItem('userId');
    const childUserId = storage.getItem('childCustomerId');
    const isChildCustomer = storage.getItem('isChildCustomer');

    return isChildCustomer ? childUserId : userId;
};

export const getCurrentCustomer = (children_list: any) => {
    const currentCustomerId = getCurrentCustomerId();
    return [children_list.find((child: any) => child.customer_id === currentCustomerId)];
};

export const convertCentimeterVolumeWithUnit = (volume: number, targetUnit: string) => {
    const centimeterDivider: Record<string, number> = {
        cm: 1,
        inch: 2.54,
        ft: 30.48,
        mtr: 100,
    };

    const volumeDivider: number = centimeterDivider[targetUnit] ** 3;

    const convertedVolume = volume / volumeDivider;

    return convertedVolume;
};

const VOLUME_TO_DIMENSION_UNIT: Record<string, string> = {
    ccm: 'cm',
    cft: 'ft',
    cin: 'inch',
    cmtr: 'mtr',
};

export const getDimensionUnitFromVolumeUnit = (unit: string): string => {
    return VOLUME_TO_DIMENSION_UNIT[unit] ?? unit;
};


export const createConditionalObject = (sourceData: any, mappings: Record<string, string | ((data: any) => any)>) => {
    const hasAnyValue = Object.values(mappings).some((mapping) => {
        if (typeof mapping === 'function') {
            return mapping(sourceData);
        }
        return sourceData[mapping];
    });

    if (!hasAnyValue) {
        return undefined;
    }

    const result: any = {};
    Object.entries(mappings).forEach(([targetKey, mapping]) => {
        if (typeof mapping === 'function') {
            result[targetKey] = mapping(sourceData);
        } else {
            result[targetKey] = sourceData[mapping];
        }
    });

    return isEmpty(result) ? undefined : result;
};
